import { useState } from 'react';
import { Button, MultiSelectModal } from '@/components/ui';
import { fetchProductOptions, resolveProductOption } from './productSelectLoaders';

export interface ProductMultiSelectModalFieldProps {
  value: ReadonlyArray<string>;
  disabled?: boolean;
  onChange: (productIds: string[]) => void;
  emptyHint?: string;
  testId?: string;
}

export const ProductMultiSelectModalField = ({
  value,
  disabled,
  onChange,
  emptyHint = '미선택 시 전역 적용 (모든 상품)',
  testId = 'product-multi-select-modal',
}: ProductMultiSelectModalFieldProps) => {
  const [open, setOpen] = useState(false);

  const handleApply = (values: ReadonlyArray<string>) => {
    onChange([...values]);
  };

  return (
    <div className="flex flex-col gap-2" data-testid={testId}>
      <div className="flex items-stretch gap-2">
        <button
          type="button"
          onClick={() => setOpen(true)}
          disabled={disabled}
          data-testid={`${testId}-trigger`}
          className="flex min-w-0 flex-1 items-center justify-between rounded-md border px-3 py-2 text-left text-sm disabled:cursor-not-allowed disabled:opacity-60"
          style={{
            borderColor: 'var(--divider-strong)',
            background: 'var(--surface-0)',
          }}
        >
          <span
            className="truncate"
            style={{ color: value.length > 0 ? 'var(--content-strong)' : 'var(--content-muted)' }}
          >
            {value.length > 0 ? `${value.length}개 상품 선택됨` : emptyHint}
          </span>
          <span className="ml-2 shrink-0 text-xs" style={{ color: 'var(--accent-default)' }}>
            {value.length > 0 ? '변경' : '상품 선택'}
          </span>
        </button>
        {value.length > 0 ? (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            disabled={disabled}
            onClick={() => onChange([])}
            data-testid={`${testId}-clear`}
          >
            전체 해제
          </Button>
        ) : null}
      </div>

      <MultiSelectModal
        open={open}
        onOpenChange={setOpen}
        loadOptions={fetchProductOptions}
        resolveOption={resolveProductOption}
        initialValue={value}
        onApply={handleApply}
        title="적용 상품 선택"
        description="쿠폰을 적용할 상품을 다중 선택하세요."
        searchPlaceholder="상품명으로 검색"
        applyLabel="선택 적용"
        emptySelectionHint={emptyHint}
      />
    </div>
  );
};
